import React, { useState, useEffect } from 'react';

const slides = [
  {
    video: '/hero2.mp4',
    eyebrow: 'Your Journey Starts Here',
    line1: 'Grow Your Business.',
    line2: 'Grow Your Income.',
    line3: 'Grow Your Life.',
    sub: 'One Woman. Multiple Streams. Unlimited Potential.',
  },
  {
    video: '/hero1.mp4',
    eyebrow: 'Welcome to My World',
    line1: 'Building Wealth.',
    line2: 'Building Health.',
    line3: 'Building You.',
    sub: 'Multiple Streams. Limitless Possibilities.',
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [videoFade, setVideoFade] = useState(true);
  const [textVisible, setTextVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextVisible(false);
      setTimeout(() => {
        setVideoFade(false);
        setTimeout(() => {
          setCurrent(prev => (prev + 1) % slides.length);
          setVideoFade(true);
        }, 500);
        setTimeout(() => setTextVisible(true), 600);
      }, 400);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const slide = slides[current];

  return (
    <section style={{
      position: "relative", height: "100vh", minHeight: "620px",
      display: "flex", alignItems: "center", justifyContent: "center",
      textAlign: "center", overflow: "hidden",
    }}>
      {slides.map((s, i) => (
        <video
          key={s.video}
          autoPlay muted loop playsInline
          style={{
            position: "absolute", inset: 0,
            width: "100%", height: "100%", objectFit: "cover", zIndex: 0,
            opacity: i === current ? (videoFade ? 1 : 0) : 0,
            transition: "opacity 1s ease-in-out",
          }}
        >
          <source src={s.video} type="video/mp4" />
        </video>
      ))}

      <div style={{
        position: "absolute", inset: 0, zIndex: 1,
        background: "linear-gradient(160deg, rgba(30,132,73,0.35) 0%, rgba(15,50,25,0.45) 60%, rgba(201,151,58,0.10) 100%)",
      }} />

      <div style={{
        position: "relative", zIndex: 2, maxWidth: "860px", padding: "80px 20px 0",
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
      }}>


        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "clamp(42px, 7vw, 80px)",
          fontWeight: 900, lineHeight: 1.05,
          color: "#fff", marginBottom: "24px", letterSpacing: "-1px",
        }}>
          {slide.line1}<br />
          {slide.line2}<br />
          <em style={{ fontStyle: "italic", color: "#C9973A" }}>{slide.line3}</em>
        </h1>

        <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "clamp(18px, 2.5vw, 26px)",
          fontStyle: "italic", fontWeight: 300,
          color: "rgba(255,255,255,0.85)", marginBottom: "44px",
          letterSpacing: "0.5px",
        }}>
          {slide.sub}
        </p>

        <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
          <a href="#ventures" style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "12px", fontWeight: 600, letterSpacing: "2px",
            textTransform: "uppercase", textDecoration: "none",
            padding: "16px 36px", borderRadius: "2px",
            background: "#C9973A", color: "#fff", display: "inline-block",
          }}>
            Explore My Ventures
          </a>
          <a href="https://wa.me/2347069495976" target="_blank" rel="noreferrer" style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "12px", fontWeight: 600, letterSpacing: "2px",
            textTransform: "uppercase", textDecoration: "none",
            padding: "16px 36px", borderRadius: "2px",
            border: "1.5px solid rgba(255,255,255,0.7)",
            color: "#fff", display: "inline-block",
          }}>
            Lets Connect
          </a>
        </div>

        <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "32px" }}>
          {slides.map((_, i) => (
            <div key={i} onClick={() => setCurrent(i)} style={{
              width: i === current ? "32px" : "8px",
              height: "8px", borderRadius: "4px",
              background: i === current ? "#C9973A" : "rgba(255,255,255,0.4)",
              transition: "all 0.4s ease", cursor: "pointer",
            }} />
          ))}
        </div>
      </div>

      <a href="#about" style={{
        position: "absolute", bottom: "36px", left: "50%",
        transform: "translateX(-50%)", zIndex: 2,
        color: "rgba(255,255,255,0.6)", fontSize: "28px",
        textDecoration: "none",
      }}>
        &#8964;
      </a>
    </section>
  );
}
